module.exports = __webpack_public_path__ + "static/img/introduceBTypeAIcon1.b1b473c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/introduceBTypeAIcon1.png
// module id = CtAs
// module chunks = 0